import BaseService from './baseService';

export default {
  aprovarRejeitar(uploadDeclaracao) {
    return BaseService.post("uploadDeclaracao/aprovarRejeitar",uploadDeclaracao)
  },
  consultaTermoFornecedor(idFornecSolicitacao){
    return BaseService.get(`uploadDeclaracao/consultaTermoFornecedor?IdFornecSolicitacao=${idFornecSolicitacao}`);
  },
  consultaListaTermoFornecedor(idFornecSolicitacao){
    return BaseService.get(`uploadDeclaracao/consultaListaTermoFornecedor?IdFornecSolicitacao=${idFornecSolicitacao}`);
  },
  salvarTermo(uploadDeclaracao){
    return BaseService.post('uploadDeclaracao/salvarTermo',uploadDeclaracao);
  },
  aprovarRejeitarTermo(termo){
    return BaseService.put('uploadDeclaracao/aprovarRejeitarTermo',termo);
  },
  possuiTermoAceito(numCgcFornecedor){
    return BaseService.get(`uploadDeclaracao/possuiTermoAceito/${numCgcFornecedor}`);
  }
};
